import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import Preloader from './components/Preloader';
import Layout from './components/Layout';

import Home from './pages/Home';
import WhyNapho from './pages/WhyNapho';
import MarketPulse from './pages/MarketPulse';
import MarketPulsePost from './pages/MarketPulsePost';
import AskNapho from './pages/AskNapho';
import Join from './pages/Join';
import Admin from './pages/Admin';
import LegalPage from './pages/LegalPage';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Preloader />
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/why" element={<WhyNapho />} />
              <Route path="/market-pulse" element={<MarketPulse />} />
              <Route path="/market-pulse/:slug" element={<MarketPulsePost />} />
              <Route path="/ask" element={<AskNapho />} />
              <Route path="/join" element={<Join />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy" element={<LegalPage title="Privacy Policy" />} />
              <Route path="/terms" element={<LegalPage title="Terms of Use" />} />
              <Route path="/disclaimers" element={<LegalPage title="Disclaimers" />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>
  );
}
